import React, { useContext } from 'react';

import { CompanyContext } from '../../../shared/context/company/companyContext';
import HomeBanner from '../sections/Banner/CompanyBanner';
import DirectAccess from '../sections/DirectAccess/DirectAccess';
import RedirectionsCards from '../sections/RedirectionCards/RedirectionsCards';
import MetricsCard from './sections/MetricsCard/MetricsCard';
import Ranking from './sections/Ranking/Ranking';

import './DefaultHome.scss';

const DefaultHome = () => {
  const { isUSA } = useContext(CompanyContext);

  return (
    <div className={`home-container ${isUSA ? 'home-container--without-bottom-row' : ''}`}>
      <div className="first-component">
        <DirectAccess />
      </div>
      <div className="second-component">
        <MetricsCard />
      </div>
      <div className="third-component">
        <Ranking />
      </div>
      {!isUSA && (
        <>
          <div className="fourth-component">
            <HomeBanner />
          </div>
          <div className="fifth-component">
            <RedirectionsCards />
          </div>
        </>
      )}
    </div>
  );
};

export default DefaultHome;
